import React, { useEffect, useRef } from "react";
import "./ViewSignatureSamplePopup.scss";
import rightSignatureSample from "../../../assets/right-signature-sample.jpg";
import wrongSignatureOne from "../../../assets/wrong-signature-one.jpg";
import wrongSignatureTwo from "../../../assets/wrong-signature-two-new.jpg";
import wrongSignatureThree from "../../../assets/wrong-signature-three.jpg";
import { useDialogA11y } from "../../UI/Backdrop/Backdrop";

export interface IViewSignatureSamplePopupProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?:string;
}
const ViewSignatureSamplePopup = (props: IViewSignatureSamplePopupProps) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  const dialogRef = useDialogA11y(!!props.showPopup, closePopup);
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        overlayRef.current &&
        event.target === overlayRef.current
      ) {
        closePopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);

  if (!props.showPopup) {
    return null;
  }

  return (
    <div className={`overlay-other ${props?.parentClassName ?? ""}`} ref={overlayRef}>
      <div
        className="popup-other"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="sample-popup-title"
      >
        {/* Close Button */}
        <button
          type="button"
          className="close-btn"
          aria-label="Close signature guide"
          onClick={closePopup}
        >
          <i className="edel-icon-close" aria-hidden="true" />
        </button>

        <h2 className="popup-title" id="sample-popup-title">Guide for Signature Upload</h2>

        {/* Popup Content */}
        <div className="grid">
          <div className="box">
            <img
              src={rightSignatureSample}
              alt="Example of a valid clear signature"
              height={80}
              width={120}
            />
            <p className="success">Use a clear background.</p>
          </div>

          <div className="box">
            <img
              src={wrongSignatureOne}
              alt="Invalid signature on ruled background"
              height={80}
              width={120}
            />
            <p className="error"> Don't use a ruled background.</p>
          </div>

          <div className="box">
            <img
              src={wrongSignatureTwo}
              alt="Invalid signature with light stroke"
              height={80}
              width={120}
            />
            <p className="error"> Don't use a light stroke.</p>
          </div>

          <div className="box">
            <img
              src={wrongSignatureThree}
              alt="Invalid signature with thick stroke"
              height={80}
              width={120}
            />
            <p className="error"> Don't use a thick stroke.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewSignatureSamplePopup;
